(() => {
  const configEl = document.getElementById('CustomizeLoginPrompt');
  if (!configEl) return;

  const customerId = (configEl.dataset.customerId || '').trim();
  const isLoggedIn = customerId !== '' && customerId !== 'null';
  if (isLoggedIn) return;

  const customizeSelector = (configEl.dataset.customizeSelector || '.zakeke-product-button').trim();
  const modalId = (configEl.dataset.modalId || 'CustomizeLoginPromptModal').trim();
  const loginUrlBase = (configEl.dataset.loginUrl || '/account/login').trim();

  const themeButtonClasses = ['btn', 'btn--primary'];

  const applyThemeClassesToCustomizeButtons = (root = document) => {
    try {
      root.querySelectorAll(customizeSelector).forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        themeButtonClasses.forEach((cls) => el.classList.add(cls));
      });
    } catch (_) {
      // ignore invalid selectors
    }
  };

  applyThemeClassesToCustomizeButtons(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        applyThemeClassesToCustomizeButtons(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  const modal = document.getElementById(modalId);
  if (!modal) return;

  const loginBtn = modal.querySelector('[data-customize-login-action="login"]');
  const guestBtn = modal.querySelector('[data-customize-login-action="guest"]');

  let pendingCustomizeEl = null;
  let bypassOnce = false;

  const buildReturnUrl = () => `${window.location.pathname}${window.location.search}`;

  const redirectToLogin = () => {
    const url = new URL(loginUrlBase, window.location.origin);
    url.searchParams.set('return_url', buildReturnUrl());
    window.location.assign(url.toString());
  };

  const showModal = (triggerEl) => {
    pendingCustomizeEl = triggerEl;
    if (typeof modal.show === 'function') {
      modal.show(triggerEl);
    } else {
      modal.hidden = false;
      modal.removeAttribute('inert');
      modal.setAttribute('open', '');
    }
  };

  const hideModal = () => {
    if (typeof modal.hide === 'function') {
      return modal.hide();
    }
    modal.removeAttribute('open');
    modal.hidden = true;
  };

  document.addEventListener(
    'click',
    (event) => {
      if (bypassOnce) {
        bypassOnce = false;
        return;
      }

      const target = event.target;
      if (!(target instanceof Element)) return;

      if (modal.contains(target)) return;

      const customizeEl = target.closest(customizeSelector);
      if (!customizeEl) return;

      // If another script set a disabled state, respect it.
      if (customizeEl.matches('button:disabled, [aria-disabled="true"]')) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      showModal(customizeEl);
    },
    true // capture to intercept before app scripts
  );

  if (loginBtn) {
    loginBtn.addEventListener('click', (event) => {
      event.preventDefault();
      redirectToLogin();
    });
  }

  if (guestBtn) {
    guestBtn.addEventListener('click', async (event) => {
      event.preventDefault();

      await hideModal();

      if (!pendingCustomizeEl) return;

      // Allow the next click (the one we trigger) through.
      bypassOnce = true;
      pendingCustomizeEl.click();
      pendingCustomizeEl = null;
    });
  }
})();
